const Palette = () => {
  const STATE_GREY = '#76768E';
  const FRENCH_GREY = '#B4B4C8';
  const BLACK = '#08080C';
  const NIGHT = '#0C0C12';
  const GHOST_WHITE = '#F0F0F8';
  const RED = '#DC0028';

  return {
    STATE_GREY,
    BLACK,
    NIGHT,
    RED,
    GHOST_WHITE,
    FRENCH_GREY,
  };
};

export default Palette;
